import {Component, ElementRef, HostListener, Input, OnDestroy, OnInit} from "@angular/core";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../../../store";
import {filter, first, switchMap, takeUntil} from "rxjs/operators";
import {combineLatest, Subject, Subscription} from "rxjs";
import {ActivatedRoute, NavigationStart, Router} from "@angular/router";
import {DialogService} from "../../../../../../../ng2-bootstrap-modal/dialog.service";
import {DbModalService} from "../../../../../../modules/modal/modal";
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";
import {UserService} from "../../../../../../user/user.service";
import {UserManagementService} from "../../../../../../user-managment/user-management.service";
import {
  GlobalEventDispatcherService
} from "../../../../../../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {GoogleAnalyticsService} from "../../../../../../shared/services/google-analytics/google-analytics.service";
import {CookieService} from "ngx-cookie";
import {AuthService} from "../../../../../../auth/auth.service";
import {User} from "../../../../../../user/user";
import {
  UserSubscription,
  UserSubscriptionCategory,
  UserSubscriptionType
} from "../../../../../../user/user-subscription";
import {UserReferral} from "../../../../../../user/user-referral";
import {Website} from "../../../../../../websites/website/website";
import {TextUtils} from "../../../../../../shared/utils/text-utils";
import {NotificationDialogComponent} from "../../../notification-dialog/notification-dialog.component";
import {AccountUpgradedDialogComponent} from "../../../account-upgraded-dialog/account-upgraded-dialog.component";
import {ConfirmDialogComponent} from "../../../confirm-dialog/confirm-dialog.component";
import {ChosenPlan} from "../../../../payment-info/models/plan.model";
import {Utils} from "../../../../../../shared/utils/utils";
import {Config} from "../../../../../../config/config";
import {
  CopilotVideoComponent
} from "../../../../../../shared/components/dialogs/one-month-free/components/one-week-free-demo-upgrade/copilot-video/copilot-video.component";
import {PricingPageCheckoutComponent} from "./pricing-page-checkout/pricing-page-checkout.component";
import {Payment} from "../../../../../../user/payment";
import {DbResponse} from "../../../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../../shared/components/notifier/notification-type";
import {WorkspaceService} from "../../../../../../workspace/workspace.service";
import {GlobalEvent} from "../../../../../../shared/services/global-event-dispatcher/global-event";
import {Location} from "@angular/common";
import {UserSubscriptionStatus} from "../../../../../../user/user-subscription-status";
import {PaymentDialogComponent} from "../../../../../../workspace/billing/payment-dialog/payment-dialog.component";

type TabType = 'business' | 'ecommerce' | 'agency';

@Component({
    selector: "db-pricing-page",
    templateUrl: "./pricing-page-view.component.html",
    styleUrls: ["./pricing-page-view.component.scss"],
    standalone: false
})
export class PricingPageViewComponent implements OnInit, OnDestroy {

  @Input() addOwnWorkspace: any;
  @Input() user: User;
  @Input() couponCode?: string;
  @Input() fromDomain?: false;
  @Input() domainName?: string;
  @Input() customDomainFlow?: boolean;
  @Input() chosenPlan?: ChosenPlan;
  @Input() isInvited: boolean = false;
  @Input() static = false;
  @Input() showEcommerceTab = false;
  @Input() showAgencyTab = false;

  isSmallMobile = window.innerWidth <= 575;
  hasCouponForCampaign = false;
  periodSwitch: number = 12;
  loading: boolean;
  UserSubscriptionCategory = UserSubscriptionCategory;
  userHostingSubscriptions: UserSubscription[];
  subscriptionsTabs: { business: UserSubscription[], ecommerce: UserSubscription[], agency: UserSubscription[] };
  activeTab: TabType = "business";
  UserSubscriptionType = UserSubscriptionType;
  userSubscriptionStatus: typeof UserSubscriptionStatus = UserSubscriptionStatus;
  isTier1Country?: boolean;
  applyCouponForPlatform?: boolean;
  couponPercent: number = 0;
  couponDays: number = 0;
  hasFreeDays: boolean = false;
  userSubscription: UserSubscription;
  currentSubscription: UserSubscription;
  demoUser: boolean;
  expirationDate: string;
  screenWidth: number;
  isEcommerceWebsite = false;
  englishCountries = false;
  showBackButton = true;
  userLocalStorage: any;
  currentView: "plans" | "checkout" = "plans";
  navigatingBack = false;
  singlePlanMode: boolean = false;
  campaignInfo: any;
  planTypeInfo: any[];
  isDropdownOpen = false;
  shouldStackPlans: boolean = false;
  payments: Payment[];
  invitedUser: boolean;
  userReferralSubscription: UserReferral;
  hostedWebsites: Website[];
  paymentID: any = null;
  payerID: any = null;
  websites: Website[];
  connectedWebsites: Website[];
  currentWorkspaceId: number;
  emailCampaignExtend = false;
  emailCampaign = false;
  emailCampaignExtendWithCoupon = false;
  upgradeablePersonalSubscription: UserSubscription;
  upgradeableEnterpriseSubscription: UserSubscription;
  annualPrice: number;
  showSwitchAnnual: boolean;

  private ownerWorkspaceId: any;
  private _subscriptions: Subscription[];
  private readonly _destroyStream$ = new Subject<boolean>();
  private _currentUserUpgradePage = !!this._route.snapshot.queryParams['currentUser'];

  constructor(
    private readonly _dialogService: DialogService,
    private readonly _userService: UserService,
    private readonly _userManagementService: UserManagementService,
    private readonly _globalEventDispatcher: GlobalEventDispatcherService,
    public readonly activeModal: DbActiveModal,
    private readonly _googleAnalyticsService: GoogleAnalyticsService,
    private _store: Store<fromStore.DbStoreState>,
    private _cookieService: CookieService,
    private _authService: AuthService,
    private _router: Router,
    private _location: Location,
    private _route: ActivatedRoute,
    private eRef: ElementRef,
    private _modalService: DbModalService,
    private _workspaceService: WorkspaceService,
  ) {
    this._store.dispatch(new fromStore.SwitchWorkspace({switching: false, workspaceName: '', redirect: false}));
    this._store.select(fromStore.getWorkspaceIdEntities).subscribe(workspaceIdEntities => {
      this.ownerWorkspaceId = workspaceIdEntities.ownerWorkspaceId;
      this.currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || this.ownerWorkspaceId;
    });
    this._store.select(fromStore.getWebsitesLoaded)
      .pipe(
        filter((websitesLoaded: boolean) => websitesLoaded),
        switchMap(() => this._store.select(fromStore.getWebsites)),
        takeUntil(this._destroyStream$)
      )
      .subscribe((websites: Website[]) => {
        this.websites = websites.filter((website: Website) => !website.isNetwork && website.isActive && !website.isLocalhost && !website.isStopped);
        this.connectedWebsites = websites.filter((website: Website) => !website.isNetwork && website.isActive && !website.isLocalhost && !website.domain_hash && !website.isStopped);
        this.hostedWebsites = websites.filter((website: Website) => website.type === 'live' && website.isActive && !website.isLocalhost && website.domain_hash && !website.isStopped);
        this.isEcommerceWebsite = websites.some((website: Website) => !!website.isEcommerceWebsite);
      });
  }

  ngOnInit() {
    this._listenRouteParams();
    const getExperimentalCookie = this._cookieService.get("db-experiment");
    const cookieData =
      getExperimentalCookie && JSON.parse(getExperimentalCookie);

    this.isTier1Country = getExperimentalCookie
      ? JSON.parse(getExperimentalCookie) &&
      JSON.parse(getExperimentalCookie).t1PExp &&
      JSON.parse(getExperimentalCookie).t1PExp === "b"
      : false;
    this._getQueryCoupons();
    this._getUserType();
    this.getAvailableSubscriptions();
    this.getQueryParams();
    this.updateScreenSizeProperties();
    this.addSubscriptions();
    this.listenRouteChange();
    this.addOwnWorkspace = this._currentUserUpgradePage ? false : this.user.workspaces.find(el => el.workspaceId === this.ownerWorkspaceId && ['invited'].includes(el.status));

    if (!this._route.snapshot.queryParams['active_tab']) {
      if (this.showEcommerceTab) {
        this.activeTab = 'ecommerce';
      } else if (this.showAgencyTab) {
        this.activeTab = 'agency';
      }
    }
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
    this.removeSubscriptions();
  }


  private addSubscriptions(): void {
    this._subscriptions = [
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => combineLatest([
            this._store.select(fromStore.getPayments),
            this._store.select(fromStore.getOwnerWorkspace),
          ])),
          takeUntil(this._destroyStream$)
        )
        .subscribe({
          next: ([payments, ownerWorkspace]) => {
            this.payments = payments?.filter(payment =>
              payment.paymentStatus !== 'failed' &&
              payment.paymentStatus !== 'requires_source_action'
            ) ?? [];
            this.invitedUser = ['invited'].includes(ownerWorkspace?.status);
          },
        })
    ];
  }


  private listenRouteChange() {
    this._router.events
      .pipe(
        filter(event => event instanceof NavigationStart),
        takeUntil(this._destroyStream$)
      ).subscribe((navigation: NavigationStart) => {
      if (navigation.navigationTrigger === 'popstate' &&
        this.addOwnWorkspace &&
        this.user &&
        this.user.workspaces &&
        this.user.workspaces.length > 1) {
        this.switchWorkspace(true);
      }
    });
  }

  private _listenRouteParams() {
    this._route.queryParams
      .pipe(takeUntil(this._destroyStream$))
      .subscribe(params => {
        this._currentUserUpgradePage = params['currentUser'];
        this.addOwnWorkspace = this._currentUserUpgradePage ? false : this.user ? this.user.workspaces.find(el => el.workspaceId === this.ownerWorkspaceId && ['invited'].includes(el.status)) : null;
        if (params['active_tab']) {
          const activeTab = params['active_tab'].toLowerCase();
          if (['business', 'ecommerce', 'agency'].includes(activeTab)) {
            this.activeTab = activeTab as TabType;
          }
        }
      });
  }

  public switchWorkspace(backToPreviousWorkspace) {
    this.loading = true;
    let switchToWorkspace = {
      ownerWorkspaceId: localStorage.getItem('dbOwnWorkspaceId'),
      currentWorkspaceId: localStorage.getItem('dbOwnWorkspaceId'),
      currentWorkspaceRoleId: 1
    };
    if (backToPreviousWorkspace) {
      const previousWorkspace: any = localStorage.getItem('dbPreviousWorkspaceId') || this.user.workspaces.find(el => el.workspaceId !== this.ownerWorkspaceId && el.status === 'active').workspaceId;
      const previousWorkspaceRoleId: any = localStorage.getItem('dbPreviousWorkspaceRoleId') || this.user.workspaces.find(el => el.workspaceId !== this.ownerWorkspaceId && el.status === 'active').roleId;
      switchToWorkspace = {
        ownerWorkspaceId: localStorage.getItem('dbOwnWorkspaceId'),
        currentWorkspaceId: previousWorkspace,
        currentWorkspaceRoleId: previousWorkspaceRoleId
      };
    }
    this._userManagementService.switchWorkspace(switchToWorkspace.currentWorkspaceId)
      .pipe(
        filter(response => !!response),
        first()
      )
      .subscribe(response => {
        if (response.success) {
          this._globalEventDispatcher.dispatchEvent(GlobalEvent.workspaceSwitch);
          if (backToPreviousWorkspace) {
            this._router.navigate(['/websites']);
          }
        } else {
          this.loading = false;
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
      });
  }

  private removeSubscriptions(): void {
    if (this._subscriptions?.length) {
      this._subscriptions.forEach(subscription => subscription.unsubscribe());
      this._subscriptions = null;
    }
  }

  public proceedToCheckout(chosenPlan): void {
    if (!chosenPlan) {
      return;
    }
    this.chosenPlan = chosenPlan;
    const date = new Date();
    if (
      this.chosenPlan.category !== UserSubscriptionCategory.DedicatedVM
    ) {
      date.setDate(date.getDate() + 7);
      this.expirationDate = date.toDateString();
    } else {
      this._setNextBillingDate(
        date,
        this.chosenPlan.type === "month" ? 30 : 365
      );
    }
    if (this.hostedWebsites && chosenPlan && chosenPlan.services && chosenPlan.services.hosting.domain_count
      && this.hostedWebsites.length > parseInt(chosenPlan.services.domain_count?.parameter_value, 10)) {
      this._dialogService.addDialog(NotificationDialogComponent, {
        header: TextUtils.getText('text_upgradePlan'),
        message: TextUtils.getText('text_upgradeToHigherPlanDesc', {domainCount: this.hostedWebsites.length}),
        buttonText: TextUtils.getText('text_gotIt')
      });
      return;
    }

    if (this.currentSubscription?.trialClient) {
      this._showCheckoutDialog(chosenPlan);
    }
    else if (this.currentSubscription.type === UserSubscriptionCategory.REGISTERED
      && ((this.userReferralSubscription && !this.userReferralSubscription.activeCredits) || !this.userReferralSubscription)) {
      const coupon = this.couponCode ? this.couponCode : null;
      this._router.navigate(['/checkout'], {
        queryParams: {
          'subscr_id': chosenPlan.subscriptionId || chosenPlan.id,
          'coupon': coupon,
          'invitedUser': this.invitedUser
        }
      });
    }
    else {
      if (!this.payments?.length && ![chosenPlan.category, chosenPlan?.plan?.type].includes(UserSubscriptionCategory.DedicatedVM)) {
        this._dialogService.addDialog(ConfirmDialogComponent, {
          header: 'Confirm plan update',
          message: `Please confirm that you want to change your plan from ${this.currentSubscription.plan.title} to ${chosenPlan.title}.`,
          cancelButtonText: TextUtils.getText('text_cancel'),
          confirmButtonText: 'Confirm',
          confirmButtonClass: 'ds-btn-black'
        })
          .subscribe((confirmed: boolean) => {
            if (confirmed) {
              this.switchPlanDuring1wf(chosenPlan);
            }
          });
      } else {
        this._dialogService
          .addDialog(PaymentDialogComponent, {
            upgradeSubscription: [chosenPlan?.plan?.type].includes(UserSubscriptionCategory?.DedicatedVM) ? chosenPlan?.plan : chosenPlan,
            dataCenter: chosenPlan.selectedLocation,
            fromDialog: false,
          });
      }
    }
  }

  private _showCheckoutDialog(chosenPlan): void {
    if (this.static) {
      this.navigatingBack = false;
      const modal = this._modalService.open(PricingPageCheckoutComponent, {height: 600, width: 1000});
      modal.componentInstance.userSubscription = this.userSubscription;
      modal.componentInstance.expirationDate = this.expirationDate;
      modal.componentInstance.chosenPlan = chosenPlan;
      modal.componentInstance.userSubscription = this.userSubscription;
      modal.closed.subscribe(() => {
        this.closeModal(true);
      });
      modal.dismissed.subscribe(() => {
        this.closeModal(false);
      });
    } else {
      this.currentView = "checkout";
    }
  }

  changePeriod(): void {
    this.periodSwitch = this.periodSwitch === 12 ? 1 : 12;
    this.getAvailableSubscriptions();
  }

  seeAgencyTab() {
    this.activeTab = "agency";
  }

  showBusiness(): void {
    this.activeTab = "business";
  }

  showEcommerce(): void {
    this.activeTab = "ecommerce";
  }

  public closeModal(isUpgraded, fromView?): void {
    if (isUpgraded) {
      if (fromView) {
        this.currentView = 'plans'; this.resizeToNormal();
      }
      else this._modalService.dismissAll();
      localStorage.removeItem("dbCouponFromEmail");
      if (this.domainName) {
        this._generateDomainInfo(this.domainName);
      }

      /* check if it not in the websites inner page */
      const href = window.location.href;
      const afterWebsites = href.split('/websites/')[1];

      if (!afterWebsites || afterWebsites.trim() === '') {
        this._router.navigate(['/websites']);
      }
      /******************/
    }
  }

  private _setNextBillingDate(date: Date, freePeriodDays: number): void {
    let _date: Date;

    _date = new Date(date.getTime());

    if (freePeriodDays === 30) {
      _date.setUTCMonth(_date.getUTCMonth() + 1);
    } else {
      _date.setUTCFullYear(_date.getUTCFullYear() + 1);
    }

    this.expirationDate = _date.toUTCString();
  }

  private async getAvailableSubscriptions(): Promise<void> {
    try {
      await new Promise<void>((resolve) => {
        this._store.select(fromStore.getUserLoaded)
          .pipe(first())
          .subscribe(() => resolve());
      });

      const availableSubscriptions = await this._store.select(fromStore.getUserAvailableHostingSubscriptions('platform'))
        .pipe(first(res => !!res.length))
        .toPromise();

      this.userHostingSubscriptions = availableSubscriptions.filter((subscription: any) =>
        subscription && subscription.plan && subscription.plan.shortFeatures && subscription.plan.shortFeatures.active === 'true'
      );

      if (this.currentSubscription) {
        this._determineUpgradeSubscriptions();
        this._getAnnualPrice();
        if (this.currentSubscription && [UserSubscriptionCategory.PERSONAL, UserSubscriptionCategory.PREMIUM, UserSubscriptionCategory.ENTERPRISE].includes(this.currentSubscription.category)) {
          this.upgradeablePersonalSubscription = null;
        } else {
          this._getUpgradeablePersonalPlan();
        }

        if (this.currentSubscription && this.currentSubscription.isBusiness && this.currentSubscription.category !== UserSubscriptionCategory.NONE && [UserSubscriptionCategory.ENTERPRISE].includes(this.currentSubscription.category)) {
          this.upgradeableEnterpriseSubscription = null;
        } else {
          this._getUpgradeableEnterprisePlan();
          this.showSwitchAnnual = this.currentSubscription && this.currentSubscription.periodNumber < 6 &&
            this.upgradeableEnterpriseSubscription && this.upgradeableEnterpriseSubscription.periodNumber === 12 &&
            !this.currentSubscription.plan.hasAddons && this.currentSubscription.plan && this.currentSubscription.plan.price ===
            this.currentSubscription.plan.planPrice && !this.currentSubscription.isExpired &&
            ![this.userSubscriptionStatus.canceled, this.userSubscriptionStatus.failed, this.userSubscriptionStatus.expired].includes(this.currentSubscription.status);
        }
      }

    } catch (error) {
      console.error(error);
    }
  }

  private _getUpgradeableEnterprisePlan() {
    this.upgradeableEnterpriseSubscription = this.userHostingSubscriptions.find((userSubscription: UserSubscription): boolean => {
      return (userSubscription && (this.currentSubscription && this.currentSubscription.trialClient ? this.isTier1Country ? userSubscription.variant === 'b' : userSubscription.variant === 'a' : true) &&
        userSubscription.isBusiness &&
        userSubscription.plan &&
        userSubscription.category === UserSubscriptionCategory.ENTERPRISE &&
        userSubscription.plan.periodNumber === this.periodSwitch
      );
    });
  }

  private _getUpgradeablePersonalPlan() {
    this.upgradeablePersonalSubscription = this.userHostingSubscriptions?.find((userSubscription: UserSubscription): boolean => {
      return userSubscription && userSubscription.newPlan && !userSubscription.isAgency && userSubscription.plan &&
        userSubscription.category === UserSubscriptionCategory.PERSONAL && userSubscription.plan.periodNumber === this.periodSwitch;
    });
  }

  private _getAnnualPrice(): void {
    const annualPlan = this.userHostingSubscriptions.find(userSubscription =>
      userSubscription && userSubscription.plan && userSubscription.id === Number(this.currentSubscription.coupleId) && userSubscription.category === this.currentSubscription.category &&
      userSubscription.plan.periodNumber === 12
    );

    this.annualPrice = annualPlan && annualPlan.plan && annualPlan.plan.planPrice;
  }

  private _determineUpgradeSubscriptions(): void {

    const tabs: any = {
      "ecommerce": this._getTabSubscriptions('ecommerce'),
      "agency": this._getTabSubscriptions('agency')
    };

    // Only include business tab if there are NO ecommerce websites
    if (!this.isEcommerceWebsite) {
      tabs["business"] = this._getTabSubscriptions('business');
    }

    this.subscriptionsTabs = tabs;

    this._setDefaultActiveTab();

    this.updateScreenSizeProperties();
  }

  private _setDefaultActiveTab(): void {
    const currentTabHasSubscriptions = this.subscriptionsTabs?.[this.activeTab]?.length > 0;
    const currentTabExists = this.subscriptionsTabs?.hasOwnProperty(this.activeTab);

    if (!currentTabHasSubscriptions || !currentTabExists) {
      if (this.subscriptionsTabs?.business?.length > 0) {
        this.activeTab = 'business';
      } else if (this.subscriptionsTabs?.ecommerce?.length > 0) {
        this.activeTab = 'ecommerce';
      } else if (this.subscriptionsTabs?.agency?.length > 0) {
        this.activeTab = 'agency';
      }
    }
  }

  public hasUpgradeOptions(): boolean {
    const currentTabSubscriptions = this.subscriptionsTabs?.[this.activeTab] || [];

    if (currentTabSubscriptions.length === 0) {
      return false;
    }

    if (currentTabSubscriptions.length === 1) {
      const subscription = currentTabSubscriptions[0];
      return !this.isCurrentSubscription(subscription);
    }

    return currentTabSubscriptions.some(subscription => !this.isCurrentSubscription(subscription));
  }

  private isCurrentSubscription(subscription: any): boolean {
    if (!this.currentSubscription || !subscription) {
      return false;
    }

    if (this.currentSubscription.id === subscription.id ||
      this.currentSubscription.subscriptionId === subscription.subscriptionId) {
      return true;
    }

    return this.currentSubscription.category === subscription.category &&
      this.currentSubscription.plan?.periodNumber === subscription.plan?.periodNumber;
  }

  private _getTabSubscriptions(tabType: 'business' | 'ecommerce' | 'agency'): UserSubscription[] {
    const subscriptions = [];

    if (this._shouldIncludeCurrentSubscription(tabType)) {
      subscriptions.push(this.currentSubscription);
    }

    const personalSub = this._findUpgradeSubscription(UserSubscriptionCategory.PERSONAL, tabType);
    const premiumSub = this._findUpgradeSubscription(UserSubscriptionCategory.PREMIUM, tabType);
    const enterpriseSub = tabType === 'agency'
      ? this._getDefaultAgencyEnterpriseSubscription()
      : this._findUpgradeSubscription(UserSubscriptionCategory.ENTERPRISE, tabType);

    [personalSub, premiumSub, enterpriseSub].forEach(sub => {
      if (sub) subscriptions.push(sub);
    });

    return subscriptions;
  }

  private _shouldIncludeCurrentSubscription(tabType: 'business' | 'ecommerce' | 'agency'): boolean {
    if (!this.currentSubscription?.plan || this.currentSubscription.plan.type === UserSubscriptionType.REGISTERED) {
      return false;
    }

    return (tabType === 'business' && this.currentSubscription.isBusiness) ||
      (tabType === 'ecommerce' && this.currentSubscription.isEcommerce) ||
      (tabType === 'agency' && this.currentSubscription.isAgency);
  }

  private _findUpgradeSubscription(category: UserSubscriptionCategory, tabType: 'business' | 'ecommerce' | 'agency'): UserSubscription | null {
    if (!this._shouldShowCategory(category, tabType)) {
      return null;
    }

    return this.userHostingSubscriptions.find(subscription =>
      this._matchesSubscriptionCriteria(subscription, category, tabType)
    ) || null;
  }

  private _matchesSubscriptionCriteria(subscription: UserSubscription, category: UserSubscriptionCategory, tabType: string): boolean {
    if (!subscription?.plan) return false;

    const variant = this._getVariant();
    const tabMatches = this._checkTabMatch(subscription, tabType);

    return subscription.category === category &&
      subscription.variant === variant &&
      subscription.plan.periodNumber === this.periodSwitch &&
      subscription.plan.shortFeatures?.active === 'true' &&
      tabMatches;
  }

  private _getVariant(): string {
    return (this.isTier1Country && (this.currentSubscription?.trialClient || this.currentSubscription?.platformPaidClient)) ? 'b' :  'a';
  }

  private _checkTabMatch(subscription: UserSubscription, tabType: string): boolean {
    switch (tabType) {
      case 'business':
        return subscription.isBusiness;
      case 'ecommerce':
        return subscription.isEcommerce;
      case 'agency':
        return subscription.isAgency;
      default:
        return subscription.tabCategory === tabType;
    }
  }

  private _shouldShowCategory(category: UserSubscriptionCategory, tab: string): boolean {
    if (!this.currentSubscription) return true;

    const isCurrentTabType = this._isCurrentTabType(tab);
    if (!isCurrentTabType) return true;

    const currentCategory = this.currentSubscription.category;
    const excludedCategories = this._getExcludedCategories(category);

    return !excludedCategories.includes(currentCategory);
  }

  private _isCurrentTabType(tab: string): boolean {
    switch (tab) {
      case 'business':
        return this.currentSubscription.isBusiness;
      case 'ecommerce':
        return this.currentSubscription.isEcommerce;
      case 'agency':
        return this.currentSubscription.isAgency;
      default:
        return false;
    }
  }

  private _getExcludedCategories(category: UserSubscriptionCategory): UserSubscriptionCategory[] {
    switch (category) {
      case UserSubscriptionCategory.PERSONAL:
        return [UserSubscriptionCategory.PERSONAL, UserSubscriptionCategory.PREMIUM, UserSubscriptionCategory.ENTERPRISE];
      case UserSubscriptionCategory.PREMIUM:
        return this.currentSubscription.category !== UserSubscriptionCategory.NONE
          ? [UserSubscriptionCategory.PREMIUM, UserSubscriptionCategory.ENTERPRISE]
          : [];
      case UserSubscriptionCategory.ENTERPRISE:
        return this.currentSubscription.category !== UserSubscriptionCategory.NONE
          ? [UserSubscriptionCategory.ENTERPRISE]
          : [];
      default:
        return [];
    }
  }

  private _getDefaultAgencyEnterpriseSubscription(): UserSubscription | null {
    if (this.currentSubscription && this.currentSubscription.isAgency &&
      this.currentSubscription.category !== UserSubscriptionCategory.NONE &&
      [UserSubscriptionCategory.ENTERPRISE].includes(this.currentSubscription.category)) {
      return null;
    }

    const defaultWebsiteCount = '100';
    const defaultZone = 'Council Bluffs, Iowa, USA';

    return this._getMatchingEnterpriseSubscription(
      this.userHostingSubscriptions,
      defaultWebsiteCount,
      defaultZone,
      this.periodSwitch
    );
  }

  private _getMatchingEnterpriseSubscription(
    subscriptions: UserSubscription[],
    selectedWebsiteCount: string,
    selectedZone: string,
    periodSwitchValue: number
  ): UserSubscription | null {
    const matchingSubscriptions = subscriptions.filter((userSubscription: UserSubscription): boolean => {
      return userSubscription &&
        userSubscription.type === UserSubscriptionCategory.DedicatedVM &&
        userSubscription.plan &&
        userSubscription.category === UserSubscriptionCategory.ENTERPRISE &&
        userSubscription.plan.periodNumber === periodSwitchValue;
    });

    const matchingSubscription = matchingSubscriptions.find((userSubscription: UserSubscription) => {
      const coreCountMatch = userSubscription.plan.title.match(/e2-standard-(\d+)/);
      if (!coreCountMatch) {
        return false;
      }

      const coreCount = parseInt(coreCountMatch[1], 10);

      const isMatchingPlan = (
        (selectedWebsiteCount === '100' && coreCount === 4) ||
        (selectedWebsiteCount === '400' && coreCount === 8) ||
        (selectedWebsiteCount === '1K' && coreCount === 16)
      );

      const isMatchingZone = userSubscription?.plans && userSubscription.plans[selectedZone];

      if (isMatchingPlan && isMatchingZone) {
        const clonedSubscription = {...userSubscription};
        clonedSubscription.plan = userSubscription.plans[selectedZone];
        return true;
      }

      return false;
    });

    if (matchingSubscription && matchingSubscription.plans && matchingSubscription.plans[selectedZone]) {
      const result = {...matchingSubscription};
      result.plan = matchingSubscription.plans[selectedZone];
      return result;
    }

    return null;
  }

  private _applyCoupon(subscriptionId, coupon): void {
    this._authService
      .applyCoupon(subscriptionId, coupon)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      )
      .subscribe((response) => {
        if (response.success) {
          this.applyCouponForPlatform = true;
          this.couponPercent = response.data.first_amount;
          this.couponDays = response.data.free_days_before_payment;
          const date = new Date();
          date.setDate(date.getDate() + this.couponDays);
          this.expirationDate = date.toDateString();
          this.hasFreeDays =
            response.data.free_days_before_payment &&
            response.data.free_days_before_payment !== 0;
        }
      });
  }

  private _getUserType(): void {
    this._store
      .select(fromStore.getUserLoaded)
      .pipe(
        first((loaded) => loaded),
        switchMap(() =>
          combineLatest(
            this._store.select(fromStore.getUser),
            this._store.select(fromStore.getUserSubscription),
            this._store.select(fromStore.getWebsites),
            this._store.select(fromStore.getUserLocalStorage)
          )
        ),
        filter(([user, userSubscription]) => !!user && !!userSubscription),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([user, userSubscription, websites, userLocalStorage]) => {
        this.isEcommerceWebsite = websites.some(
          (website: Website) => !!website.isEcommerceWebsite
        );

        this.userSubscription = userSubscription;
        this.currentSubscription = userSubscription;
        this.isTier1Country = this.userSubscription?.plan?.shortFeatures?.variant === "b" ? true : this.isTier1Country;
        this.user = user;
        this.userLocalStorage = userLocalStorage;
        this.englishCountries = userLocalStorage && !!userLocalStorage.tier1B;
        this.demoUser = Utils.isDemoUser(userSubscription, user);

        this._store.select(fromStore.getUserReferralSubscriptionLoaded)
          .pipe(
            filter((loaded: boolean) => loaded),
            switchMap(() => this._store.select(fromStore.getUserReferralSubscription))
          )
          .subscribe((userReferralSubscription: UserReferral) => {
            this.userReferralSubscription = userReferralSubscription;
          });
      });
  }

  private _generateDomainInfo(domainName): void {
    const domainInfo = JSON.stringify({
      want_domain: 1,
      domain_name: domainName || "",
    });
    localStorage.setItem("dbOnboardingDomainInfo", domainInfo);
    this.userLocalStorage["suggestedDomainName"] = domainName;
    this._updateLocalStorage();
  }

  private _updateLocalStorage(): void {
    this._userService
      .setToLocal(this.userLocalStorage)
      .pipe(first((response) => !!response, null))
      .subscribe((response) => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadUserLocalStorage());
          this._store.dispatch(new fromStore.LoadUser());
        }
      });
  }

  private _showSuccessfullyUpgradedDialog(): void {
    this._dialogService.addDialog(AccountUpgradedDialogComponent, {
      currentSubscription: this.userSubscription,
      upgradedFromTrial: true,
      upgradedFromBooster: false,
      isDemoUser: !!Utils.isDemoUser(this.userSubscription, this.user),
    });
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event): void {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.updateScreenSizeProperties();
  }

  private updateScreenSizeProperties(): void {
    this.shouldStackPlans = window.innerWidth <= 768;
  }

  openVideoPopup(): void {
    this._modalService.open(CopilotVideoComponent, {
      height: 563, width: 1000, hasOutsideRightCloseBtn: true,
      hasCloseBtn: false, backdrop: 'static'
    });
  }

  resizeToNormal() {
    this.activeModal.resize(960, 1076);
  }

  openChat(): void {
    window['Smooch']?.open();
    this._store.dispatch(new fromStore.ToggleChatOverlay(false));
  }

  public chooseSubscription(subscription: UserSubscription, extend: boolean | undefined = false): void {
    if (extend && (this.currentSubscription.plan.planPrice / this.currentSubscription.plan.periodNumber > parseInt(this.userReferralSubscription.activeCredits, 10) + this.currentSubscription.plan.proratedCredit)) {
      this._dialogService.addDialog(AccountUpgradedDialogComponent, {
        extendNotEnough: true,
        currentSubscription: this.currentSubscription
      });
    }
    if (this.hostedWebsites && subscription && subscription.plan && subscription.plan.services && subscription.plan.services.hosting.domain_count
      && this.hostedWebsites.length > parseInt(subscription.plan.services.hosting.domain_count.parameter_value, 10)) {
      this._dialogService.addDialog(NotificationDialogComponent, {
        header: TextUtils.getText('text_upgradePlan'),
        message: TextUtils.getText('text_upgradeToHigherPlanDesc', {domainCount: this.hostedWebsites.length}),
        buttonText: TextUtils.getText('text_gotIt')
      });
      return;
    }
    if ((this.currentSubscription.type === UserSubscriptionCategory.STARTER
        || this.currentSubscription.type === UserSubscriptionCategory.REGISTERED)
      && ((this.userReferralSubscription && !this.userReferralSubscription.activeCredits) || !this.userReferralSubscription)) {

    }
  }

  public switchPlanDuring1wf(subscription): void {
    for (const key of Config.paypalLocalKeys) {
      if (localStorage.getItem(key)) {
        localStorage.removeItem(key);
      }
    }
    const paymentType = this.currentSubscription.paymentType === 'paypal' ? this.currentSubscription.plan.recurring ? 'paypal_recurring' : 'paypal' : 'card';
    this.loading = true;
    this._workspaceService.upgradeSubscription(subscription.id, null, null, null, paymentType, subscription.subscriptionTitle, this.paymentID, this.payerID, 0, null, null)
      .pipe(filter((response: DbResponse) => !!response),
        first())
      .subscribe((response): void => {
        this.loading = false;
        if (response.success) {
          this.handleSuccessfulUpgrade(response.data);
        } else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
      });
  }

  private handleSuccessfulUpgrade(data): void {
    if (data.result && data.result.approval_link) {
      window.location.replace(data.result.approval_link);
    } else {
      this.navigateToWebsites();
    }
  }

  private navigateToWebsites(): void {
    this._router.navigate(['/websites'], {
      queryParams: {
        upgraded_account: 1,
        upgraded_from_trial: this.currentSubscription.category === UserSubscriptionCategory.STARTER,
        upgraded_from_booster: this.currentSubscription.boosterProClient
      }
    }).then(() => {
      this._store.dispatch(new fromStore.UpdateUserSubscription());
    });
  }

  public getQueryParams() {
    const queryParams: any = (<any>this._route.queryParams).value;
    this.applyCouponForPlatform = !!queryParams.coupon && this.currentSubscription.trialClient;

    this.couponCode = queryParams.coupon || queryParams.dbCouponFromEmail || localStorage.getItem('dbCouponFromEmail') || '';

    if ((this.applyCouponForPlatform || this.emailCampaignExtendWithCoupon || this.emailCampaign) && this.upgradeablePersonalSubscription) {
      this._applyCoupon(this.upgradeablePersonalSubscription.id, this.couponCode);
    }

    const queryParamsIndex: number = this._router.url.indexOf('?');
    if (queryParamsIndex !== -1) {
      this._location.replaceState(this._router.url.substring(0, queryParamsIndex));
    }
  }

  private _getQueryCoupons() {
    if (localStorage.getItem('dbCouponFromEmail')) {
      this.emailCampaignExtend = localStorage.getItem('dbCouponFromEmail').indexOf(Config.couponPrefixForExtend) > -1;
      this.emailCampaign = localStorage.getItem('dbCouponFromEmail').indexOf(Config.popupCouponPrefixForAutoApply) > -1;
      this.emailCampaignExtendWithCoupon = localStorage.getItem('dbCouponFromEmail').indexOf(Config.couponPrefixForExtendWithCoupon) > -1;
      this.campaignInfo = this._userService.getCampaignInfo();
    }
  }

  public shouldShowTabs(): boolean {
    let availableTabsCount = 0;
    if (this.subscriptionsTabs?.business?.length > 0) availableTabsCount++;
    if (this.subscriptionsTabs?.ecommerce?.length > 0) availableTabsCount++;
    if (this.subscriptionsTabs?.agency?.length > 0) availableTabsCount++;
    return availableTabsCount > 1;
  }

}
